export default "__VITE_ASSET__CpoWntNf__"